import {Income} from './income.model';
import {EmployeeType} from '../employee-type.model';
import {ObligationStatus} from '../obligation-status.model';
import {AdvanceEmiOption} from "../AdvanceEmiPlan";

export class Obligations {
    public readonly rent: number;
    public readonly emi: number;

    constructor(rent?: number, emi?: number)
    constructor(rent: number, emi: number) {
        this.rent = rent;
        this.emi = emi;
    }

    public static from(json): Obligations {
        const obligations = new Obligations();
        Object.assign(obligations, json);
        return obligations;
    }

    public getStatus(): ObligationStatus {
        return this.emi > 0 ? ObligationStatus.HAVE_LOAN : ObligationStatus.DEBT_FREE;
    }
}

export class EligibilityCheckRequest {
    private userId: string;
    private loanAmount: number;
    private requestedAmount: number;
    private income: Income;
    private employeeType: EmployeeType;
    private obligations: Obligations;
    private tenure: number;
    private partnerId: string;
    private advanceEmiOption: AdvanceEmiOption;

    constructor(userId: string, partnerId: string, loanAmount: number, income: Income,
                obligations: Obligations, tenure: number, employeeType: EmployeeType, requestedAmount?: number, advanceEmiOption?: AdvanceEmiOption) {
        this.userId = userId;
        this.loanAmount = loanAmount;
        this.income = income;
        this.obligations = obligations;
        this.tenure = tenure;
        this.employeeType = employeeType;
        this.partnerId = partnerId;
        this.requestedAmount = requestedAmount;
        this.advanceEmiOption = advanceEmiOption;
    }
}
